// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__PJ8Gx","item":"PaymentsMobile_item__2bAXQ","label":"PaymentsMobile_label__21Lav","amount":"PaymentsMobile_amount__eeoDL"};